import { createSelector } from 'reselect';
import { roadblockSelector } from './appSelector';

export const authenticationEnabled = createSelector(
    roadblockSelector,
    (roadblock) => !roadblock
);

export const userAuthSelector = createSelector(
    ({ authentication = {} }) => {
        const { authTypes = [] } = authentication;
        return authTypes;
    },
    (authTypes) => authTypes
);

export const ipSelector = createSelector(
    ({ authentication = {} }) => {
        const { ip: { info = null } = {} } = authentication;
        return info;
    },
    (ipInfo) => ipInfo
);

export const adobePassSelector = createSelector(
    ({ authentication = {} }) => {
        const { adobePass: { info = null } = {} } = authentication;
        return info;
    },
    (adobePassInfo) => adobePassInfo
);

export const userLocationSelector = createSelector(
    ({ authentication = {} }) => {
        const { ip: { location = null } = {} } = authentication;
        return location;
    },
    (userLocation) => userLocation
);

export const adobePassInitializedSelector = createSelector(
    ({ authentication = {} }) => {
        const { adobePass: { initialization: { completeTime } = {} } = {} } = authentication;
        return !!completeTime;
    },
    (initialized) => initialized
);

export const adobePassAuthenticatedSelector = createSelector(
    ({ authentication = {} }) => {
        const { adobePass: { isAuthenticated } = {} } = authentication;
        return !!isAuthenticated;
    },
    (isAuthenticated) => isAuthenticated
);



// WEBPACK FOOTER //
// ./app/selectors/authenticationSelectors.js